module.exports = __webpack_public_path__ + "img/web_07.11561ea1.png";